
export default function searchBanners(banners, eligible) {
    const nonSubscriber = banners.find(banner => banner.Customer === 'Non Subscriber');
    const subscriber = banners.find(banner => banner.Customer === 'Subscriber');
    const $container = document.getElementById('category-search-banner');

    if (!$container) {
        return;
    }

    if ($container && subscriber && eligible) {
        setDisplayByCustomerClassName($container, 'subscriber');
        return;
    }

    if ($container && nonSubscriber && !eligible) {
        setDisplayByCustomerClassName($container, 'non-subscriber');
        return;
    }

    setDisplayByCustomerClassName($container, 'default');
}

function setDisplayByCustomerClassName($container, customerClassName) {
    const $banner = $container.querySelector(`.${customerClassName}`);
    const HIDE = 'jsHide';

    if (!$banner) {
        return;
    }

    document.getElementById('categoryDescription')?.classList.add(HIDE);
    $banner.classList.remove(HIDE);
    [...$container.querySelectorAll(`.category-search-banner:not(.${customerClassName})`)].forEach($element => $element.remove());
}